import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getFollowing } from '@/services/follow.service';
import { FollowingListComponent } from './FollowingList.component';

interface FollowingListProps {
  userId: string;
  username: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const FollowingList: React.FC<FollowingListProps> = ({
  userId,
  username,
  open,
  onOpenChange,
}) => {
  const navigate = useNavigate();
  const [following, setFollowing] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (open) {
      const fetchFollowing = async () => {
        setLoading(true);
        try {
          const followingList = await getFollowing(userId);
          setFollowing(followingList);
        } catch (error) {
          console.error('Error fetching following:', error);
        } finally {
          setLoading(false);
        }
      };

      fetchFollowing();
    }
  }, [userId, open]);

  const handleUserClick = (userUsername: string) => {
    navigate(`/user/${userUsername}`);
  };

  return (
    <FollowingListComponent
      username={username}
      following={following}
      loading={loading}
      open={open}
      onOpenChange={onOpenChange}
      onUserClick={handleUserClick}
    />
  );
};

